import React from "react";
import {Card, CardActionArea, CardContent, CardMedia, Grid, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import pieChartPreview from "../assets/reports/pie-chart.svg";
import barChartPreview from "../assets/reports/bar-chart.svg";
import radarChartPreview from "../assets/reports/radar-chart.svg";
import {useTranslation} from "react-i18next";

const ReportsCategoriesPage = () => {
    const {t} = useTranslation();
    return (
        <PageLayout title={t("pages.reports.categories.title")}>
            <CardContent sx={{minHeight: 200, maxHeight: "90%", overflowY: "auto"}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{height: "100%"}}>
                            <CardActionArea component={RouterLink} to="/reports/categories/pieChart">
                                <CardMedia
                                    component="img"
                                    height="160"
                                    image={pieChartPreview}
                                    alt={t("pages.reports.categories.cards.pie.alt")}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {t("pages.reports.categories.cards.pie.title")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t("pages.reports.categories.cards.pie.description")}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{height: "100%"}}>
                            <CardActionArea component={RouterLink} to="/reports/categories/barChart">
                                <CardMedia
                                    component="img"
                                    height="160"
                                    image={barChartPreview}
                                    alt={t("pages.reports.categories.cards.bar.alt")}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {t("pages.reports.categories.cards.bar.title")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t("pages.reports.categories.cards.bar.description")}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{height: "100%"}}>
                            <CardActionArea component={RouterLink} to="/reports/categories/radarChart">
                                <CardMedia
                                    component="img"
                                    height="160"
                                    image={radarChartPreview}
                                    alt={t("pages.reports.categories.cards.radar.alt")}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {t("pages.reports.categories.cards.radar.title")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t("pages.reports.categories.cards.radar.description")}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            </CardContent>
        </PageLayout>
    );
};

export default ReportsCategoriesPage;
